import CustomSteps from "components/general/CustomSteps";
import { useState } from "react";
import UploadFile from "components/general/UploadFile";
import { useLeaveBalanceBulkUploadMutation } from "apis/services/bulkUpload";
import ModalWrapper from "../ModalWrapper";
import { FileUploadProps } from "./types";
import styles from "./styles.module.scss";
import DomainUrl from "apis/Domain";

export default function UploadLeaveDocuments({
  isVisible,
  setIsVisible,
}: FileUploadProps) {
  const [bulkUpload] = useLeaveBalanceBulkUploadMutation();

  const handleCustomButtonClick = () => {
    const tempFile = `${DomainUrl}/media/leave_balance_uploads/4c5551f9-99f4-414c-999d-3f0fd170f1e6.xlsx`;

    const fileName = "template.xls";

    const link = document.createElement("a");
    link.href = tempFile;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [currentStep, setCurrentStep] = useState(0);
  const [fileList, setFileList] = useState<any[]>([]);

  const upload_steps = [
    // {
    //   title: "Download Requests Data",
    //   content: "",
    //   buttonText: "Download ( 25 Staff ) ",
    //   modalTitle: "Bulk Upload Staff",
    // },
    {
      title: "Upload New Leave File",
      content: (
        <UploadFile
          fileList={fileList}
          setFileList={(x: any) => setFileList(x)}
          type="single"
        />
      ),
      buttonText: "Download file Template",
      modalTitle: "Bulk Upload Leave File",
    },
  ];

  const handleStepChange = (step: number) => {
    setCurrentStep(step);
  };

  const handleClose = () => {
    /* 
// @ts-ignore */
    setIsVisible(false);
    setFileList([]);
  };

  const onUploadFile = (cb: any) => {
    const formData = new FormData();
    formData.append("sheet", fileList[0]);

    bulkUpload(formData)
      .unwrap()
      .then(() => {
        cb?.();
      });
  };

  return (
    <ModalWrapper
      size="large"
      headerTitle={upload_steps[currentStep].modalTitle}
      isVisible={isVisible}
      setIsVisible={setIsVisible}
      isFooterHidden
    >
      <div className={styles.container}>
        <CustomSteps
          steps={upload_steps}
          filesLength={fileList.length}
          showSteps={false}
          showBackButton
          customButtonClick={handleCustomButtonClick}
          handleClose={handleClose}
          /* 
// @ts-ignore */
          onStepChange={(step) => handleStepChange?.(step)}
          onUploadHandler={onUploadFile}
        />
      </div>
    </ModalWrapper>
  );
}
